// UI strings for the per-person stress feedback (stressfocus/; engine pedagogy/stress-focus.ts, Axel's
// decision of 2026-10-09): the words a person's takes against Peterson's clip missed twice, named in
// neutral words only ("Harjoitellaan painoa: X"), never a score or a warning. Shown on the week's Puhu
// step, in Tämä viikko under Puhu, and as the Puhu take of a pronunciation week's round.
// Style: docs/FINNISH-STYLE.md (sinä-muoto, no jargon, no intro text).
import { defineArea } from '../area';

export const stressFocusFi = {
  /** Before the words: "Harjoitellaan painoa: morghūlis, dohaeris". */
  label: 'Harjoitellaan painoa',
  /** The Puhu take of the round (Varjosta ja äänitä) when it is a focus word's line. */
  takeHow: 'Kuuntele Petersonia, sano perässä ja äänitä.',
};

export const stressFocusEn: typeof stressFocusFi = {
  label: 'Practising stress',
  takeHow: 'Listen to Peterson, say it after him and record it.',
};

// Messages.stressFocus (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('stressFocus', stressFocusFi, stressFocusEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof stressFocusFi> {}
}
